module.exports = __webpack_public_path__ + "media/assets/main-visual@2x-7222edc92f4969e276d7ec0de4bd621b.png";